<!-- <div class="row">
    <div class="col-12" style="text-align: end;">
        <div>
            <p>AGENT NAME: <span> value </span> &nbsp; &nbsp; ALLOCATION DATE: <span> value </span> </p> 
        </div>
    </div>
</div> -->
<mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()"> 
    X 
</mat-icon>

<mat-tab-group>
    <mat-tab label="New FollowUp">
        <div class="container-fluid" *ngIf="StopFollowup_Status">
            <div class="row">
                <div class="col-12">
                    <p style="color: red;">FollowUp Stopped for this Customer Account..!</p>
                </div>
            </div>
        </div>
        <div class="container-fluid" *ngIf="!StopFollowup_Status">
           
            <div class="loader" *ngIf="loader_view"></div>
            <div class="row" *ngIf="!loader_view">
                <div class="col-12">
                    <form [formGroup]="FollowUpForm">
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="">FollowUp ID  <span style="color: red;">*</span> </label>
                                <input type="text" placeholder="FollowUp ID" class="form-control" formControlName="_id" disabled>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Log Date <span style="color: red;">*</span></label>
                                <input type="text" placeholder="Log Date" class="form-control" formControlName="log_date" disabled>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Log Type <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="log_type" [(ngModel)]="log_type">
                                    <option value=""> Choose</option>
                                    <option *ngFor="let item of LogTypeList" [value]="item.logtype">{{item.logtype}}</option>
                                </select>
                            </div>
                            
                            <div class="form-group col-md-4" >
                                <label for="">Main Status <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="mstatus" [(ngModel)]="mstatus" (change)="onMstatus($event)">
                                    <option value="">Choose</option>
                                    <option *ngFor="let item of mStatusList " [value]="item.mstatus_name">{{item.mstatus_name}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4" >
                                <label for="">Sub Status <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="substatus" [(ngModel)]="substatus">
                                    <option value="">Choose</option>
                                    <option *ngFor="let item of sStatusList" [value]="item.sstatus_name">{{item.sstatus_name}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4" *ngIf="showPTP">
                                <label for="">PTP Amount <span style="color: red;">*</span></label>
                                <input type="text" placeholder="PTP amount" [(ngModel)]="ptp_amount" class="form-control" formControlName="ptp_amount">
                            </div>
                            <div class="form-group col-md-4" *ngIf="showPTP">
                                <label for="">PTP Date <span style="color: red;">*</span></label>
                                <input type="date" placeholder="PTP Date" [(ngModel)]="f_date" class="form-control" formControlName="ptp_status">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">FollowUp Date <span style="color: red;">*</span></label>
                                <input type="date" placeholder="Follow Up Date" [(ngModel)]="fdate" class="form-control" formControlName="fdate">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Bank CODE <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="bcode" [(ngModel)]="bcode">
                                    <option value="">Choose</option>
                                    <option *ngFor="let item of bankCodeList" [value]="item.bcode">{{item.bcode}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Action Taken <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="actiontaken" [(ngModel)]="actiontaken">
                                    <option value="">Choose</option>
                                    <option *ngFor="let item of actionstakenList" [value]="item.actiontaken_name">{{item.actiontaken_name}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Next Action <span style="color: red;">*</span></label>
                                <select class="form-control" formControlName="actiontotake" [(ngModel)]="actiontotake">
                                    <option value="">Choose</option>
                                    <option *ngFor="let item of actionstakenList" [value]="item.actiontaken_name">{{item.actiontaken_name}}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-4">
                                <label for="">Contact Email</label>
                                <input type="text" placeholder="Contact Email" [(ngModel)]="contact_email" class="form-control" formControlName="contact_email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">Contact Mobile</label>
                                <input type="text" placeholder="Contact Mobile" [(ngModel)]="contact_mobile" class="form-control" formControlName="contact_mobile">
                            </div>
                           

                            <div class="form-group col-md-4">
                                <label for="">Labour Card</label>
                                <input type="number" min="0" [(ngModel)]="labour_card" placeholder="Labour Card" class="form-control" formControlName="labour_card" >
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">DED Number</label>
                                <input type="number" min="0" [(ngModel)]="ded_number" placeholder="DED Number" class="form-control" formControlName="ded_number" >
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">MOL Status</label>
                                <select formControlName="mol_status" class="form-control" [(ngModel)]="mol_status">
                                    <option value="">Choose</option>
                                    <option value="ACTIVE-MOL">ACTIVE-MOL</option>
                                    <option value="CANCELLED-MOL">CANCELLED-MOL</option>
                                    <option value="EXPIRED-MOL">EXPIRED-MOL</option>
                                    <option value="NOT FOUND-MOL">NOT FOUND-MOL</option>
                                    <option value="ABSCOND-MOL">ABSCOND-MOL</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">DED Status</label>
                                <select formControlName="ded_status" class="form-control" [(ngModel)]="ded_status">
                                    <option value="">Choose</option>
                                    <option value="ACTIVE-DED">ACTIVE-DED</option>
                                    <option value="EXPIRED-DED">EXPIRED-DED</option>
                                    <option value="UNDER TRANSACTION-DED">UNDER TRANSACTION-DED</option>
                                    <option value="NOT FOUND-DED">NOT FOUND-DED</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">UID Status</label>
                                <input type="text" placeholder="UID Status" [(ngModel)]="uid_status" class="form-control" formControlName="uid_status" >
                            </div>
                            <div class="form-group col-md-4">
                                <label for="">UID Number</label>
                                <input type="number" min="0" placeholder="UID Number" [(ngModel)]="uid_number" class="form-control" formControlName="uid_number" >
                            </div>
                            <div class="form-group col-md-12">
                                <label for="">Remarks <span style="color: red;">*</span></label>
                                <textarea name="" id="" cols="30" rows="5" [(ngModel)]="remarks" placeholder="Remarks" class="form-control" formControlName="remarks"></textarea>
                            </div>
                            <div class="form-group col-md-12">
                                <input type="file" class="custom-file-input" id="customFile" (change)="getFile($event)">
                                <label class="custom-file-label" for="customFile">Choose file</label>
                            </div>
                            <p *ngIf="uploaded">File Uploaded</p>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button class="btn btn-sm btn-success" (click)="addNewFollowUp()">ADD</button>
                        </div>
                    </form>        
                </div>
            </div>
        </div>   
        
        
        <div class="container-fluid">
            <hr>
            <div class="row" style="text-align: end; margin:10px;">
                <p style="font-size: 14px;"><b>FollowUp List</b></p>
            </div>
            <div class="row">
                <div class="col-12">
                    <ag-grid-angular #agGrid 
                            style="width: auto; height: 300px;"
                            class="ag-theme-alpine"
                            [rowData]="FollowUpList"
                            [rowSelection]="'multiple'"
                            [columnDefs]="FollowUpcolumnDefs"
                            [pagination]="true">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="New Payment"><app-user-new-payment></app-user-new-payment> </mat-tab>
    <mat-tab label="New Settlement"> <app-user-new-settlement></app-user-new-settlement> </mat-tab>
    <mat-tab label="New Field Visit">  <app-new-field-visit></app-new-field-visit> </mat-tab>
  </mat-tab-group>
